
export default number => new Intl.NumberFormat('en-US').format(number);
